import type { HTMLAttributes } from 'react';

import { ClassNames } from '@/shared/classNames';

export const Skeleton = ({ className, ...properties }: HTMLAttributes<HTMLDivElement>) => (
  <div aria-hidden="true" className={ClassNames('bg-line animate-pulse rounded-md', className)} {...properties} />
);
